import I18n from "i18n-js";
import { fetch } from "../../../appContainer";
import {
  GET_SCALES_LIST_IN_PROGRESS,
  GET_SCALES_LIST_SUCCESS,
  GET_SCALES_LIST_FAIL,
  GET_SCALE_INFOS_IN_PROGRESS,
  GET_SCALE_INFOS_SUCCESS,
  GET_SCALE_INFOS_FAIL,
  POST_SCALE_IN_PROGRESS,
  POST_SCALE_SUCCESS,
  POST_SCALE_FAIL,
  PUT_SCALE_IN_PROGRESS,
  PUT_SCALE_SUCCESS,
  PUT_SCALE_FAIL,
  DELETE_SCALE_IN_PROGRESS,
  DELETE_SCALE_SUCCESS,
  DELETE_SCALE_FAIL,
} from "../constants";
import { SUBMIT_SUCCESS, SUBMIT_FAIL } from "../../common/constants";

/**
 * Create scale
 *
 * @param {Object} scale
 */
export function createScale(scale) {
  return (dispatch) => {
    dispatch({ type: POST_SCALE_IN_PROGRESS });

    fetch("api").createScale(
      scale,
      () => {
        const message = I18n.t("alerts.add:scale.success");

        dispatch({ type: SUBMIT_SUCCESS, payload: { message } });
        dispatch({ type: POST_SCALE_SUCCESS });
      },
      (error) => {
        let message = I18n.t("alerts.common.fail");
        if (error.violations?.length) {
          message = I18n.t(
            `alerts.add:scale.fail:${error.violations[0].path}`,
          );
        }

        dispatch({ type: SUBMIT_FAIL, payload: { message } });
        dispatch({
          type: POST_SCALE_FAIL,
          payload: { violations: error.violations },
        });
      },
    );
  };
}

/**
 * Update leak scale
 *
 * @param {String} uuid
 * @param {Object} scale
 */
export function updateScale(uuid, scale) {
  return (dispatch) => {
    dispatch({ type: PUT_SCALE_IN_PROGRESS });

    fetch("api").updateScale(
      uuid,
      scale,
      () => {
        const message = I18n.t("alerts.update:scale.success");

        dispatch({ type: SUBMIT_SUCCESS, payload: { message } });
        dispatch({ type: PUT_SCALE_SUCCESS });
      },
      (error) => {
        let message = I18n.t("alerts.common.fail");
        if (error.violations?.length) {
          message = I18n.t(
            `alerts.update:scale.fail:${error.violations[0].path}`,
          );
        }

        dispatch({ type: SUBMIT_FAIL, payload: { message } });
        dispatch({
          type: PUT_SCALE_FAIL,
          payload: { violations: error.violations },
        });
      },
    );
  };
}

/**
 * Get scales list
 */
export function getScalesList() {
  return (dispatch) => {
    dispatch({ type: GET_SCALES_LIST_IN_PROGRESS });

    fetch("api").getScalesList(
      (list) => {
        dispatch({ type: GET_SCALES_LIST_SUCCESS, payload: { list } });
      },
      () => dispatch({ type: GET_SCALES_LIST_FAIL }),
    );
  };
}

/**
 * Delete scale
 *
 * @param {String} uuid
 */
export function deleteScale(uuid) {
  return (dispatch) => {
    dispatch({ type: DELETE_SCALE_IN_PROGRESS });

    fetch("api").deleteScale(
      uuid,
      () => {
        const message = I18n.t("alerts.delete:scale.success");

        dispatch({ type: SUBMIT_SUCCESS, payload: { message } });
        dispatch(getScalesList());
        dispatch({ type: DELETE_SCALE_SUCCESS });
      },
      () => {
        const message = I18n.t("alerts.delete:scale.fail");

        dispatch({ type: DELETE_SCALE_FAIL });
        dispatch({ type: SUBMIT_FAIL, payload: { message } });
      },
    );
  };
}

/**
 * Get scale infos
 */
export function getScaleInfos(uuid) {
  return (dispatch) => {
    dispatch({ type: GET_SCALE_INFOS_IN_PROGRESS });

    fetch("api").getScaleInfos(
      uuid,
      (infos) => {
        dispatch({ type: GET_SCALE_INFOS_SUCCESS, payload: { infos } });
      },
      () => dispatch({ type: GET_SCALE_INFOS_FAIL }),
    );
  };
}
